<!-- Topbar Start -->
<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
    <div class="container-fluid">
        <button type="button" class="menu-grid-button" (click)="menuButtonClicked.emit()" title="Menu" aria-label="Menu">
            <i [attr.data-feather]="'grid'" appFeatherIcon></i>
        </button>

        <!-- LOGO: on a phone the search takes its place -->
        <a routerLink="/" class="navbar-brand mr-0 mr-md-2 logo d-none d-sm-block">
            <span class="logo-lg">
                <img src="assets/images-bundle/logo.svg" alt="Cinemapp logo" height="24" />
            </span>
            <span class="logo-sm">
                <img src="assets/images-bundle/logo.svg" alt="Cinemapp logo" height="24">
            </span>
        </a>

        <!-- The general search: a title, user, theater, cast member or streaming service, to its admin page -->
        <app-topbar-search></app-topbar-search>

        <ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">
            <li class="dropdown notification-list align-self-center profile-dropdown" ngbDropdown>
                <a class="nav-link dropdown-toggle nav-user mr-0" ngbDropdownToggle href="javascript: void(0);" role="button">
                    <div class="media user-profile">
                        <img src="assets/images/users/avatar.jpg" alt="user-image" class="rounded-circle align-self-center" />
                        <div class="media-body text-left">
                            <h6 class="pro-user-name ml-2 my-0">
                                <span>{{user.name}}</span>
                                <span class="pro-user-desc text-muted d-block mt-1">Admin</span>
                            </h6>
                        </div>
                        <i [attr.data-feather]="'chevron-down'" class="ml-2 align-self-center" appFeatherIcon></i>
                    </div>
                </a>
                <div class="dropdown-menu profile-dropdown-items dropdown-menu-right" ngbDropdownMenu>
                    <a href="javascript:void(0);" (click)="logout()" class="dropdown-item notify-item" ngbDropdownItem>
                        <i [attr.data-feather]="'log-out'" class="icon-dual icon-xs mr-2" appFeatherIcon></i>
                        <span>&nbsp;Logout</span>
                    </a>
                </div>
            </li>
        </ul>
    </div>

</div>
<!-- end Topbar -->
